module.exports = __webpack_public_path__ + "static/media/virtual_assist.6a2da24c.jpg";